<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>

  <div class="modal-header">
    <h3 class="modal-title font">Detalle codigos LER</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
        <div *ngIf="isConsentimientoMode" class="mt-3">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h4 class="m-0" style="font-size:16px">Códigos LER no incluidos en el consentimiento</h4>
        <button type="button" class="btn btn-primary" (click)="addCodigosLer()" [disabled]="isReadOnly">Añadir</button>
      </div>
      <mat-form-field appearance="outline" class="consent-cod-ler-select">
        <mat-select [formControl]="codigosLerNuevosControl" placeholder="-- Seleccione codigos LER --" multiple>
          <mat-option *ngFor="let ler of codigosLerDisponibles" [value]="ler.id">
            {{ ler.tipoCodigo }} - {{ ler.descripcion }} (Peligroso: {{ ler.peligrosidad ? 'SI' : 'NO' }})
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="recordsTotal > 0; else emptyState">
      <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
        <div class="datatable-container table-responsive">
          <!-- TABLA Listado con resultados de búsqueda -->
          <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
            (actionButton)="action($event)"></lib-ge-table>
          <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
            <div class="d-flex mt-2" *ngIf="hasMultiplePages()">
              <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
              </ngb-pagination>
            </div>

            <div class="mt-2 selectPage" *ngIf="hasMultiplePages()">
              <label for="itemsPerPage">Mostrar:</label>
              <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
              </select>
            </div>
          </div>
          <!-- FIN TABLA Listado con resultados de búsqueda -->
        </div>
      </div>
    </div>

    <ng-template #emptyState>
      <div class="mensaje-container">
        <p class="mensaje-linea">No hay códigos LER asociados.</p>
      </div>
    </ng-template>
  </div>

  <div class="modal-footer actions">
    <div class="button-group">
      <button *ngIf="isConsentimientoMode" type="button" class="btn btn-primary" (click)="saveConsentimientoCodigos()" [disabled]="isReadOnly">Guardar</button>
      <button type="button" class="btn btn-outline-primary" (click)="cerrar()" aria-label="Cerrar">Cerrar</button>
    </div>
  </div>
</div>
